import { Container } from "react-bootstrap";

function TC() {
  return (
    <Container fluid>
      <Container className="mx-auto">
        <div className="mx-auto p-3 p-2">
          <br />
          <h1 className="text-primary title-primary h-2 ">
            TERMS AND CONDITIONS OF USE
          </h1>
          <br />
          <br />
          <p className="text-sm">
            We value our relationship with you and we want you to feel
            comfortable and confident when using our Platform and Services. The
            objectives of these Terms are to inform you of the terms which apply
            to your access to the Platform and Services, what we expect from
            you, and what you can expect from us as you use and interact with
            our Platform and the Services provided by us, our Strategic Partners
            and third party service providers.
            <br />
            <br />
            These Terms and Conditions of Use (the &ldquo;Terms&rdquo;) applies
            to and govern the use of or access to the website www.Kbiafiling.in
            , and other similar platforms (hereinafter, collectively referred to
            as the &ldquo;Platform&rdquo;), by the User (hereinafter,
            &ldquo;you&rdquo; or &ldquo;your&rdquo;).
            <br />
            <br />
            The Platform is provided by ACCIG Experts Private Limited
            (hereinafter, &ldquo;Company&rdquo; &ldquo;Kbiafiling&rdquo; or
            &ldquo;our&rdquo; or &ldquo;we&rdquo; or &ldquo;us&rdquo;), a
            company incorporated under the Companies Act 2013, having its
            registered office at Suite No.701, 10 Clive Row, Rampuria Chambers,
            Kolkata, West Bengal 700001.
            <br />
            <br />
            User and Company are each a &ldquo;Party&rdquo; and collectively the
            &ldquo;Parties&rdquo;.
            <br />
            <br />
            These Terms are an electronic record in terms of the (Indian)
            Information Technology Act, 2000 and rules thereunder as applicable
            and as amended from time to time. This electronic record is
            generated by a computer system and does not require any physical or
            digital signatures. These Terms are published in accordance with the
            provisions of Rule <br /> 3(1)(a) of the Information Technology
            (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021
            framed under the (Indian) Information Technology Act, 2000 (as
            amended from time to time), that require publishing the terms of
            services and practices for access or usage of Platform and Services.
            These Terms constitute a binding and legally enforceable contract
            between the Company and User (as defined below).
            <br />
            <br />
            By registering on or using the Platform you agree to be bound by the
            Terms. If you are using the Platform on behalf of an organization,
            you are agreeing to the Terms on behalf of that organization (in
            which event, &ldquo;you&rdquo;, &ldquo;your&rdquo; or
            &ldquo;User&rdquo; will refer to that organization).
            <br /> <br />
            You represent that you are at least 18 (eighteen) years of age and
            have not been previously suspended or removed by the Company, or
            disqualified for any other reason, from availing the Services or
            using the Platform. In addition, you represent and warrant that you
            have the right, authority and capacity to agree to the Terms and to
            abide by them. You shall not impersonate any person or entity, or
            falsely state or otherwise misrepresent your identity, age or
            affiliation with any person or entity. In the event of any violation
            of the Terms, the Company reserves the right to suspend or
            permanently prevent you from availing the Services or using the
            Platform.
            <br />
            <br />
            If you do not agree to be bound by these terms, you must not use the
            platform. By continuing to use the platform or services you
            expressly agree and undertake to be bound by these terms. Subject to
            applicable laws, these Terms (and any changes thereto) will become
            applicable to you retrospectively on and from the date of your first
            use of the Platform.
          </p>
          <br />
          <br />
          <p className="text-sm">
            <strong>1. Changes to these Terms</strong>
            <br />
            <br />
            1.1. Please note that these Terms may change from time to time. We
            reserve the right to modify or amend these Terms. While we will make
            reasonable efforts to keep you posted on any updates to these Terms,
            to make sure that you are aware of any changes, we encourage you to
            periodically review them whenever accessing or using the Platform to
            be continuously aware of the changes that we may be carrying out to
            these Terms.
            <br />
            <br />
            1.2. The &ldquo;Last Updated&rdquo; date at the top of the Terms
            indicates when the most recent modifications were made to the Terms.
            In the event we modify these Terms, by continuing to access and use
            the Platform, you will have confirmed your acceptance to any such
            modifications. Your continued use will be adequate proof that you
            have expressly agreed to the terms of these Terms which shall apply
            from the date of your first use of the Platform. In addition, when
            using the Platform, you will be subject to any posted guidelines,
            supplementary terms, policies, or disclaimers made available or
            issued by us from time to time, including but not limited to the
            Privacy Policy available at&nbsp;
            <a className="text-link" href="https://Kbiafiling.in/privacypolicy">
              Kbiafiling.in/Privacy
            </a>
            . All such supplementary terms, policies, guidelines or disclaimers
            are hereby incorporated by reference into these Terms.
            <br />
            <br />
            1.3. If you have any comments or questions regarding the Terms, or
            wish to report any violation of the Terms, you may contact us at
            support@Kbiafiling.in.
            <br />
            <br />
          </p>
          <br />
          <br />
          <p className="text-sm">
            <strong>2.About the Platform and the Services</strong>
            <br />
            <br />
            2.1. The Platform is primarily a technology service provider which
            provides services for various tax return preparation and filing such
            as Income Tax, GST, TDS etc. It also provides tax and other business
            consultancy services, including but not limited to various statutory
            registrations and licences, to further and support your business
            needs.
            <br />
            <br />
            2.2. The Platform also allows you to avail the Services directly
            from the Company, its Strategic Partners, and third-party service
            providers associated with the Company from time to time, and the
            Platform facilitates communication with such Strategic Partners and
            third parties for availing the Services.
            <br />
            <br />
            2.3. We further clarify that we are not an investment advisor
            registered with SEBI and only provide a platform to facilitate you
            to obtain information on the various Investment options available.
            <br />
            <br />
            2.4. You hereby agree and acknowledge that the data and information
            provided on the Platform does not constitute advice of any nature
            whatsoever, and shall not be relied upon by you while making
            investment decisions and you shall be solely responsible for any
            investment decisions. For ascertaining your risk appetite, we may
            request you to provide such information as may be necessary for the
            purpose of providing information on the available investment
            options, including without limitation the following: age, investment
            objectives and the purposes of the investment, income details,
            existing investments/ assets, risk appetite/ tolerance, and
            liability/borrowing details.
            <br />
            <br />
            2.5. We reserve the right to add, modify or discontinue, temporarily
            or permanently, the Services and Platform (or any part thereof) with
            or without cause. We shall not be liable for any such addition,
            modification, suspension or discontinuation of the Services.
          </p>
          <br />
          <br />
          <p className="text-sm">
            <strong>3. Sign-Up and Consent Requirements</strong>
            <br />
            <br />
            3.1. To avail the Services, you will have to provide us with
            necessary details including but not limited to your name, mother’s
            name, father’s name, date of birth, gender, Permanent Account Number
            (“PAN”), signature, marital status, nominee details, cancelled
            cheque, photograph and video recording, email id, phone number,
            educational or professional qualification, business name, business
            address, nature of business, Goods and Service Tax Network (“GSTN”),
            Tax Deduction and Collection Account Number (“TAN”), bank account
            details, Unified Payment Interface (“UPI”) ID, and/or other payment
            related details etc.
            <br />
            <br />
            3.2. You agree to provide the above stated information, or such
            other information as may be necessary or required by us to provide
            the Services, at the time of sign-up or at any subsequent stage.
            Further, you acknowledge that the act of providing your Aadhaar ID
            is voluntary in nature unless mandated under applicable law. You may
            choose to provide us with an alternative KYC proof.
            <br />
            <br />
            3.3. You warrant to provide true, accurate, current and complete
            information about yourself and you agree to not misrepresent your
            identity or your account information. You agree to keep your account
            information up to date and accurate.
            <br />
            <br />
            3.4. If you upload information relating to any third parties, you
            should ensure that any such information is uploaded only after
            obtaining express written consent from them for using their
            information on the Platform. Further, you should ensure that express
            written consent from such persons is obtained to receive
            communications from the Company regarding: information about us and
            the Services; promotional offers and services from us and our third
            party service providers and Strategic Partners, and any other matter
            in relation to the Services. If such third parties fail to provide
            written consent, or withdraw consent, you shall immediately cease to
            use the Services in relation to them. You will be solely responsible
            for obtaining such consent from third parties and we assume that
            such consent is sought and received by you if you provide such
            information relating to any of such third parties any time during
            the use of the Platform.
            <br />
            <br />
            3.5. If you provide any information that is false, inaccurate or
            outdated, or we have reasonable grounds to suspect that such
            information is false, inaccurate or outdated, we will be entitled to
            suspend or terminate your account and prohibit any and all current
            or future use of the Platform by you. You are responsible for
            maintaining the confidentiality of the account and are fully
            responsible for all activities that occur under your account.
            <br />
            <br />
            3.6. You agree to immediately notify us in writing at
            support@Kbiafiling.in of any disclosure or unauthorized use of your
            profile or any other breach of security with respect to your
            profile.
          </p>
          <br />
          <br />
          <p className="text-sm">
            <strong>4. Use of and Access to the Platform</strong>
            <br />
            <br />
            4.1. You agree to use the Platform only for lawful purposes, and
            that you are responsible, liable and accountable for all activities
            that take place through your use of Platform or availing the
            Services. We exclude any liability arising out of use of the
            Platform.
            <br />
            <br />
            4.2. You understand, accept and agree that the payment facility
            provided by us is neither a banking nor financial service but we
            merely act as a facilitator providing an electronic payment option,
            automated online electronic payment option, for the transactions on
            the Platform using the existing authorized banking infrastructure
            and the payment gateway/payment aggregator networks. Further, by
            providing payment facility, we are neither acting as trustees nor
            acting in a fiduciary capacity with respect to the transaction.
            <br />
            <br />
            4.3. Service Level Terms: We will use commercially reasonable
            efforts to provide you the Platform. We will provide you with
            reasonable technical support services in accordance with our
            standard practices. We do not make any commitment that the Platform
            will be available at all times or during any down time
            <br />
            (a) caused by outages to any public Internet backbones, networks or
            servers,
            <br />
            (b) caused by any failures of your equipment, systems or local
            access services,
            <br />
            (c) for previously scheduled maintenance,
            <br />
            (d) caused by any third party vendor or service provider of the
            Company,
            <br />
            (e) caused by any failure of systems or servers of any third party
            including that of the government and its authorities and/or
            financial institutions such as asset management companies or any
            financial intermediaries,
            <br />
            (f) attributable to events such as strikes, riots, insurrection,
            fires, floods, explosions, war, governmental action, labor
            conditions, earthquakes, natural disasters, hacking, phishing or
            interruptions in Internet services to an area where the Company or
            its servers are located or co-located, or
            <br />
            (g) required pursuant to instructions received by us from any
            governmental or regulatory authority.
            <br />
            <br />
            4.4. Updates: From time to time, we may provide upgrades, patches,
            enhancements, or fixes for the Platform to you generally without
            additional charge and such updates will become part of the Platform
            and subject to the Terms. Notwithstanding the foregoing, we shall
            have no obligation under these Terms or otherwise to provide any
            such updates. You understand that the Company may cease supporting
            old versions or releases of the Platform at any time in its sole
            discretion.
            <br />
            <br />
            4.5. By accessing or using the Platform or by availing Services, you
            agree not to:
            <br />
            <br />
            4.5.1. host, display, upload, modify, publish, transmit, update or
            share any information (if provided with the functionality to do so
            on the Platforms) that:
            <br />
            a) belongs to another person and to which the user does not have any
            right;
            <br />
            b) is defamatory, obscene, pornographic, pedophilic, invasive of
            another&rsquo;s privacy, including bodily privacy, insulting or
            harassing on the basis of gender, libellous, racially or ethnically
            objectionable, relating or encouraging money laundering or gambling,
            or otherwise inconsistent with or contrary to the laws of India;
            <br />
            c) is harmful to minors;
            <br />
            d) infringes any patent, trademark, copyright or other proprietary
            rights
            <br />
            e) violates any law for the time being in force;
            <br />
            f) deceives or misleads the addressee about the origin of the
            message or knowingly and intentionally communicates any information
            which is patently false or misleading in nature but may reasonably
            be perceived as a fact;
            <br />
            g) impersonates another person;
            <br />
            h) threatens the unity, integrity, defence, security or Sovereignty
            of India, friendly relations with foreign States, or public order,
            or causes incitement to the commission of any cognizable offence or
            prevents investigation of any offence or is insulting any foreign
            states;
            <br />
            i) contains software virus or any other computer code, file or
            program designed to interrupt, destroy or limit the functionality of
            any computer resource;
            <br />
            j) is patently false and untrue, and is written or published in any
            form, with the intent to mislead or harass a person, entity or
            agency for financial gain or to cause any injury to any person.
            <br />
            4.5.2. violate the Terms or any law for the time being in force;
            <br />
            4.5.3. conduct or forward surveys, contests, pyramid schemes or
            chain letters involving the Services;
            <br />
            4.5.4. impersonate any person or entity, falsely claim or otherwise
            misrepresent your affiliation with any person or entity, or access
            the accounts of others without permission, forge another person’s
            digital signature, misrepresent the source, identity, or content of
            information transmitted via the Services, perform any other similar
            fraudulent activity
            <br />
            4.5.5. infringe our or any third party’s patent, trademark,
            copyright or other intellectual property rights, proprietary rights,
            rights of publicity or privacy;
            <br />
            4.5.6. use the Services if you are under the age of 18 years;
            <br />
            4.5.7. post or transmit any message (if provided with the
            functionality to do so on the Platforms) which discloses private or
            personal matters concerning any person or, is grossly harmful,
            harassing, hateful and/or disparaging;
            <br />
            4.5.8. post or transmit (if provided with the functionality to do so
            on the Platforms) any message, data, image or program which is
            blasphemous, vulgar, or offensive in nature;
            <br />
            4.5.9. refuse to cooperate in an investigation or provide
            confirmation of your identity or any other information provide by
            you to us;
            <br />
            4.5.10. remove, circumvent, disable, damage or otherwise interfere
            with security-related features of the Platform and Services or
            features that enforce limitations on the use of the Services or the
            Platform;
            <br />
            4.5.11. reverse engineer, decompile, disassemble or otherwise
            attempt to discover the source code of as regards Services or
            Platform or any part thereof, except and only to the extent this is
            expressly permissible by applicable law;
            <br />
            4.5.12. use the Services or the Platform in any manner that could
            damage, disable, overburden, or impair it, including, without
            limitation, using the Services or the Platform in an automated
            manner;
            <br />
            4.5.13. modify, adapt, translate or create derivative works based
            upon the Services and Platform or any part thereof, except and only
            to the extent that that this is permissible by applicable law;
            <br />
            4.5.14. intentionally interfere with or damage operation of the
            Services or the Platform or any other user’s enjoyment of it, by any
            means, including uploading or otherwise disseminating viruses,
            adware, spyware, worms, or other malicious code or file/ programme
            with contaminating or destructive features or which are designed to
            interrupt, destroy or limit the functionality of any computer
            resource;
            <br />
            4.5.14. use any robot, spider, other automatic device, or manual
            process to monitor or copy the Platform without prior written
            permission;
            <br />
            4.5.16. take any action that imposes an unreasonably or
            disproportionately large load on our infrastructure/network;
            <br />
            4.5.17. use the facilities and capabilities of the Platform to
            conduct any activity or solicit the performance of any illegal
            activity or other activity which infringes the rights of others;
            <br />
            4.5.18. use the Platform to collect or obtain personal information,
            including without limitation, financial information, about other
            users of the Platform, except and only as expressly provided in the
            Terms;
            <br />
            4.5.19. use the Services in a manner that results in or may result
            in complaints, disputes, reversals, chargebacks, fees, fines,
            penalties and other liability to us, a third party or you.
          </p>
          <br />
          <br />
          <p className="text-sm">
            <strong>5. Information</strong>
            <br />
            <br />
            5.1. While we use commercially reasonable efforts to facilitate
            provisions of the information including the filing status of your
            tax returns, status of your investments, etc. on the Platform, we
            are not responsible for any errors or omissions, or for the results
            obtained from the use of or reliance on this information.
            Specifically, certain links in Platform may connect to other
            websites maintained by third parties over which we have no control.
            If you access such links, your use of the third party websites will
            be governed by the policies of such websites. We encourage you to
            review the terms and policies of such websites.
            <br />
            <br />
            5.2. We do not make any representations as to the accuracy or any
            other aspect of information contained in other websites. All
            information made available through the Platform is provided "as is",
            with no guarantee, representation, or commitment of completeness,
            accuracy, timeliness or of the results obtained from the use of this
            information, and without warranty of any kind, express or implied,
            including, but not limited to warranties of performance,
            merchantability and fitness for a particular purpose.
          </p>
          <br />
          <br />
          <p className="text-sm">
            <strong>6. Intellectual Property Rights and Ownership</strong>
            <br />
            <br />
            6.1. We own the rights in the design, compilation, and look and feel
            of our Platform. It also includes rights in all copyrighted works,
            trademarks, designs, inventions, and other intellectual property.
            Subject to compliance with these Terms, we grant you a
            non-exclusive, non-transferable, non-sub licensable, royalty-free,
            revocable, and limited access to use the Platform and the Services
            in accordance with these Terms.
            <br />
            <br />
            6.2. You agree not to copy, distribute, modify or make derivative
            works of any of our content or use any of our intellectual property
            rights in any way not expressly permitted by us.
            <br />
            <br />
            6.3. Use of data: Notwithstanding anything to the contrary contained
            herein, when you enter or upload your data onto the Platform, you
            expressly agree, covenant, consent and grant us, our Strategic
            Partners, our third party service providers and our group companies,
            affiliates, all rights, licences and consents to host, use, copy,
            transmit, process, store, share, analyse, display, make derivations,
            and back up all data you submit to us through our services and as
            required by us including but not limited to personal data and any
            other data relating to financial information of yourself and others,
            and further to:
            <br />
            a) belongs to another person and to which the user does not have any
            right;
            <br />
            b) is defamatory, obscene, pornographic, pedophilic, invasive of
            another&rsquo;s privacy, including bodily privacy, insulting or
            harassing on the basis of gender, libellous, racially or ethnically
            objectionable, relating or encouraging money laundering or gambling,
            or otherwise inconsistent with or contrary to the laws of India;
            <br />
            c) is harmful to minors;
            <br />
            d) infringes any patent, trademark, copyright or other proprietary
            rights
            <br />
            e) violates any law for the time being in force;
            <br />
            f) deceives or misleads the addressee about the origin of the
            message or knowingly and intentionally communicates any information
            which is patently false or misleading in nature but may reasonably
            be perceived as a fact;
            <br />
            g) impersonates another person;
            <br />
            h) threatens the unity, integrity, defence, security or Sovereignty
            of India, friendly relations with foreign States, or public order,
            or causes incitement to the commission of any cognizable offence or
            prevents investigation of any offence or is insulting any foreign
            states;
            <br />
            i) contains software virus or any other computer code, file or
            program designed to interrupt, destroy or limit the functionality of
            any computer resource;
            <br />
            j) is patently false and untrue, and is written or published in any
            form, with the intent to mislead or harass a person, entity or
            agency for financial gain or to cause any injury to any person.
            <br />
            <br />
            6.4. Data loss: Data loss is an unavoidable risk when using any
            technology. You are responsible for maintaining copies of your data
            entered into the Platform or for availing the Services.
            <br />
            <br />
            6.5. No compensation: Whatever the cause of any downtime, access
            issues or data loss, your only recourse is to discontinue using the
            Platform or the Services.
          </p>
          <br />
          <br />
          <p className="text-sm">
            <strong>7. Know your Customer/Client Requirements</strong>
            <br />
            <br />
            You agree and provide your express consent to provide certain
            information and documents that may be necessary to ascertain your
            eligibility to use the Platform or avail the Services including but
            not limited to your KYC Documents to us, to entities for whom we act
            as a technology facilitator and platform provider, to online payment
            gateways, operators and aggregators, and, or to our affiliates to
            use, copy, transmit, process, store, share, analyse, make
            derivations, and back-up such KYC Documents and information. For the
            purpose of these Terms, ‘KYC Documents’ shall mean to include mobile
            number, mother’s name, father’s name, email address, password, date
            of birth, gender, PAN, signature, marital status, nominee details,
            cancelled cheque, photograph and video recording, etc. and other
            information which may be sought either during Sign-up or at any
            stage later. You agree and warrant to provide valid, true, complete,
            and up-to-date KYC Documents. You acknowledge and agree that any
            incorrect or misleading information provided shall constitute a
            material breach of these Terms.
          </p>
          <br />
          <br />
          <p className="text-sm">
            <strong>8. Communication Policy</strong>
            <br />
            <br />
            8.1. You agree to receive communications from the Company regarding:
            (i) information relating to use of the Platform or Services; (ii)
            information about the Company and the Services; (iii) promotional
            offers and services from the Company and its Strategic Partners and
            third party partners, and (iv) any other matter in relation to the
            Services. In case you access the Platform on behalf of a third party
            (after obtaining their prior consent), you acknowledge and agree
            that we are permitted to send any or all of the above communications
            to your customers or other third parties whose information you have
            made available on the Platform.
            <br />
            <br />
            8.2. We may send alerts to the mobile phone numbers provided by you,
            either of yourself or your customers or any third parties, via
            e-mail, SMS, Whatsapp messages or push notifications or any other
            means. If your mobile number is registered in the Do Not Disturb
            (“DND”) list of TRAI, you may not receive SMS from us. In such case,
            you will be responsible for taking all steps to deregister from the
            DND list and will not hold us liable for non-receipt of SMS.
            <br />
            <br />
            8.3. We shall not be under any obligation to confirm the
            authenticity of the person(s) receiving the alert. You cannot hold
            the Company liable for non-availability of the SMS/email alert/push
            notifications service in any manner whatsoever.
            <br />
            <br />
            8.4. The SMS/e-mail alert/push notification service provided by us
            is an additional facility provided for your convenience and that it
            may be susceptible to error, omission and/or inaccuracy. You shall
            not hold the Company liable for any loss, damages, claim, expense
            including legal cost that may be incurred/suffered by you on account
            of the SMS/e-mail alert/push notification facility.
            <br />
            <br />
            8.5. The clarity, readability, accuracy and promptness of providing
            the SMS/e-mail alert/push notification service depend on many
            factors including the infrastructure and connectivity of the network
            service provider. We shall not be responsible for any non-delivery,
            delayed delivery or distortion of the alert in any way whatsoever.
            <br />
            <br />
            8.6. You understand that the Company cannot and does not guarantee
            or warrant that files available for download through the Platform
            will be free of viruses, worms or other code that may be damaging.
            You are responsible for implementing procedures to satisfy your
            particular requirements of internet security and for accuracy of
            data input and output.
          </p>
          <br />
          <br />
          <p className="text-sm">
            <strong>9. Termination of Access to the Platform</strong>
            <br />
            <br />
            We may terminate or suspend your access to Platform or access to all
            or any of data: (i) at our discretion; (ii) if you fail to comply
            with these Terms or the Privacy Policy; (iii) in case of inactivity
            for long periods; or (iv) in case of any fraud, insolvency or
            bankruptcy in relation to you. You agree that our right to terminate
            does not depend on whether you breach these Terms or not.
          </p>
          <br />
          <br />
          <p className="text-sm">
            <strong>10. Warranties and Disclaimers</strong>
            <br />
            <br />
            10.1. We are a technology platform service provider. We are not and
            will not be responsible for any claim or for any damages suffered,
            whether by you, the third parties of the Users whose information is
            recorded on the Platform, or any other person or party, that are
            related, directly or indirectly, to or arise out of the same
            including any payments made by you or by any third parties of the
            User using the payment link generated using the Platform.
            <br />
            <br />
            10.2. YOUR USE OF THE PLATFORM AND THE SERVICES IS AT YOUR SOLE
            RISK. THE PLATFORM, THE SERVICES ARE PROVIDED ON AN “AS IS” AND “AS
            AVAILABLE” BASIS. EXCEPT AS OTHERWISE EXPRESSLY PROVIDED IN THESE
            TERMS, THE COMPANY, ITS STRATEGIC PARTNERS, AND THEIR RESPECTIVE
            OFFICERS, DIRECTORS, EMPLOYEES, AGENTS AND OTHER REPRESENTATIVES,
            EXPRESSLY DISCLAIM ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR
            IMPLIED, INCLUDING, BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NON-INFRINGEMENT. WITHOUT LIMITING THE GENERALITY OF THE FOREGOING,
            THE COMPANY MAKES NO WARRANTY THAT: (I) THE PLATFORM OR THE SERVICES
            WILL MEET YOUR EXPECTATIONS; (II) THE PLATFORM OR THE SERVICES WILL
            BE UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE; (III) INFORMATION
            THAT MAY BE OBTAINED VIA THE PLATFORM OR THE SERVICES WILL BE
            ACCURATE OR RELIABLE; (IV) ANY ERRORS IN THE PLATFORM OR THE
            WEBSITES WILL BE CORRECTED.
          </p>
          <br />
          <br />
          <p className="text-sm">
            <strong>11. Exclusion of Damages</strong>
            <br />
            <br />
            WE SHALL NOT UNDER ANY CIRCUMSTANCES BE LIABLE FOR ANY DAMAGES OF
            ANY KIND ARISING OUT OF, IN CONNECTION WITH OR RELATING TO THE USE
            OF OR INABILITY TO USE THE PLATFORM, INCLUDING ANY LIABILITY: (I) AS
            A PUBLISHER OF INFORMATION; (II) FOR ANY INCORRECT OR INACCURATE
            INFORMATION OR ANY ‘BUG’ OF THE PLATFORM OR THE SERVICES; (III) FOR
            ANY UNAUTHORIZED ACCESS TO OR DISCLOSURE OF YOUR TRANSMISSIONS OR
            DATA; (IV) FOR STATEMENTS OR CONDUCT OF ANY THIRD PARTY ON OR VIA
            THE PLATFORM; (V) FOR ANY DISPUTES BETWEEN USERS OF THE PLATFORM OR
            THE SERVICES, OR BETWEEN A USER OF THE PLATFORM OR THE SERVICES AND
            A THIRD PARTY; OR (VI) FOR ANY OTHER MATTER RELATING TO THE PLATFORM
            OR THE SERVICES, OR ANY THIRD PARTY. THIS IS A COMPREHENSIVE
            LIMITATION OF LIABILITY THAT APPLIES TO ALL DAMAGES OF ANY KIND,
            INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL OR CONSEQUENTIAL
            DAMAGES, WHETHER BASED ON BREACH OF CONTRACT, BREACH OF WARRANTY,
            TORT (INCLUDING NEGLIGENCE), PRODUCT LIABILITY OR OTHERWISE, EVEN IF
            AN INDIVIDUAL ADVISES US OF THE POSSIBILITY OF SUCH DAMAGES. THE
            LIMITATIONS OF LIABILITY SET FORTH HEREIN ARE FUNDAMENTAL ELEMENTS
            OF THE BASIS OF THE BARGAIN BETWEEN THE COMPANY AND YOU. THE
            PRODUCTS, INFORMATION AND SERVICES OFFERED ON AND THROUGH THE
            PLATFORM OR THE SERVICES WOULD NOT BE PROVIDED TO YOU WITHOUT SUCH
            LIMITATIONS.
          </p>
          <br />
          <br />
          <p className="text-sm">
            <strong>12. Indemnification</strong>
            <br />
            <br />
            12.1. Notwithstanding anything contained in this Agreement, you
            agree to defend, indemnify and hold harmless the Company (and its
            affiliates, officers, directors and employees) upon demand from and
            against any and all damages, actions, proceedings, claims, demands,
            costs, losses, liabilities, diminution in value, loss of earnings,
            profits and revenue, opportunity costs, expenses (including court
            costs and reasonable attorneys’ legal fees) in connection with,
            arising out of, or in relation to (i) breach or non-compliance of
            its obligations, consents, grants, undertakings, representations or
            warranties under these Terms, and (ii) misrepresentation,
            negligence, fraud, willful concealment and misconduct (iii) misuse
            of the Services and Platform for any illegal or unauthorised
            purposes; (iv) any injuries to persons or damage to property, body,
            business character, reputation including theft, resulting from your
            acts or omissions; (v) any claims by a third party on Company for
            the acts committed or omitted by you; and (vi) any violation of
            applicable law.
            <br />
            <br />
            12.2. You agree that any violation by you will constitute an
            unlawful and unfair business practice, and will cause irreparable
            harm to the Company and/ or its Strategic Partners and third party
            service providers, as the case may be, for which monetary damages
            would be inadequate, and you consent to the Company obtaining any
            injunctive or equitable relief that they deem necessary or
            appropriate in such circumstances. These remedies are in addition to
            any other remedies that the Company may have at law or in equity. If
            the Company takes any legal action against you as a result of your
            violation of these Terms, they will be entitled to recover from you,
            and you agree to pay all reasonable attorneys’ fees and costs of
            such action, in addition to any other relief that may be granted.
          </p>
          <br />
          <br />
          <p className="text-sm">
            <strong>13. Miscellaneous</strong>
            <br />
            <br />
            13.1. Notice: All notices, requests, demands, approvals, requests
            for approvals or other communications under the Terms shall be in
            writing. Notice will be sufficiently given for all purposes as
            follows: (i) upon delivery when personally delivered to the
            recipient, (ii) upon receipt when mailed by certified mail (iii)
            upon delivery when delivered by recognized international overnight
            courier, and (iv) upon receipt when sent by fax with confirmation.
            <br />
            <br />
            13.2. Merger/Modification: Each Party acknowledges that it has read
            the Terms, it understands it, and agrees to be bound by its terms,
            and further agrees that this is the complete and exclusive statement
            of the Terms between the Parties, which supersedes and merges all
            prior proposals, understandings and all other agreements, oral and
            written, between the Parties relating to the Terms.
            <br />
            <br />
            13.3. Governing Law and Jurisdiction: These Terms shall be governed
            by and construed and enforced in accordance with the laws of India.
            Subject to other provisions in this Clause, courts in Kolkata shall
            have exclusive jurisdiction over all issues arising out of these
            Terms or the use of the Services. Any controversies, conflicts,
            disputes, or differences arising out of these Terms shall be
            resolved by arbitration in Kolkata in accordance with the
            Arbitration and Conciliation Act, 1996 for the time being in force,
            which is deemed to be incorporated by reference in this Clause. The
            tribunal shall consist of 1 (one) arbitrator appointed by us. The
            language of the arbitration shall be English. The parties to the
            arbitration shall keep the arbitration confidential and not disclose
            to any person, other than on a need to basis or to legal advisors,
            unless required to do so by law. The decision of the arbitrator
            shall be final and binding on all the Parties hereto.
            <br />
            <br />
            13.4. Investment Advisory Caution: Investment in the securities
            market (including mutual fund investments) are subject to market
            risks, please read all investments, offer and scheme-related
            documents carefully, before investing. For the purposes of these
            Terms, the term “Offer Document(s)” shall refer to a collective term
            for Offer Document, Scheme Information Document, Statement of
            Additional Information, Key Information Memorandum, issued by the
            AMC that manages the mutual fund or the issuer of the relevant
            financial product. There is no guarantee for any returns on
            investments made in mutual fund scheme(s). Past performance of
            mutual funds/schemes do not indicate the future performance of the
            schemes and may not necessarily provide a basis of comparison with
            other investments.
            <br />
            <br />
            13.5. Severability: If any provision of the Terms is invalid under
            any applicable statute or rule of law, it is to that extent to be
            deemed omitted and all other terms and provisions of the Terms shall
            nevertheless remain in full force and effect so long as the economic
            or legal substance of the transactions contemplated hereby is not
            affected in any manner materially adverse to any Party. Upon such
            determination that any term or other provision is invalid, illegal
            or incapable of being enforced, the Parties shall negotiate in good
            faith to modify the Terms so as to effectuate the original intent of
            the Parties as closely as possible in an acceptable manner in order
            that the transactions contemplated hereby are consummated as
            originally contemplated to the greatest extent possible.
            <br />
            <br />
            13.6. Waiver: A waiver by either Party of any terms or conditions of
            the Terms in any instance shall not be deemed or construed to be a
            waiver of such term or condition for the future, or of any
            subsequent breach thereof. All remedies, rights, undertakings,
            obligations and agreements contained in the Terms shall be
            cumulative, and none of them shall be in limitation of any other
            remedy, right, undertaking, obligation or agreement of either Party.
            <br />
            <br />
            13.7. Relationship of Parties: The Parties are not employees,
            agents, partners or joint venturers of each other. You shall not
            have the right to enter into any agreement on behalf of the Company.
            <br />
            <br />
            13.8. Entire Terms: The entire understanding between the Parties
            hereto relating to the subject matter hereof is contained herein and
            the Parties make no warranties, representations or undertakings
            hereto except as expressly provided herein.
            <br />
            <br />
            13.9. Assignment: Notwithstanding anything contained herein, you
            agree and covenant that the Company may, at its sole discretion, be
            entitled to assign its rights and obligations under this Terms to
            any of its affiliates or to any entity, and in such case, such
            affiliate or entity shall be entitled to enforce these Terms.
            <br />
            <br />
            13.10. Survival: Notwithstanding any termination, cancellation or
            expiration of the Terms, the provisions hereof that are intended to
            continue and survive, shall continue and survive.
            <br />
            <br />
            13.11. Force Majeure: Neither Party shall be liable for a failure or
            delay in performing any of its obligations under the Terms if, but
            only to the extent that, such failure or delay is due to causes
            beyond the reasonable control of the affected party, including, but
            not limited to
            <br />
            (1) acts of God;
            <br />
            (2) fire or explosion (except to the extent caused by the negligence
            or willful misconduct of the affected party);
            <br />
            (3) unusually severe weather;
            <br />
            (4) war, invasion, riot, or other civil unrest;
            <br />
            (5) governmental laws, orders, restrictions, actions, embargoes, or
            blockages;
            <br />
            (6) national or regional emergency; and
            <br />
            (7) injunctions, strikes, lockouts, labor trouble, or other
            industrial disturbances; provided that the party affected shall
            promptly notify the other of the force majeure condition and shall
            exert reasonable efforts to eliminate, cure, or overcome any such
            causes and to resume performance of its obligations as soon as
            practicable.
            <br />
            <br />
            13.12. Maintenance of Records: You shall maintain the records
            independently of the Platform (by way of physical copies et cetera)
            and the Company reserves the right to seek copies of such records
            for their own use including record keeping. You acknowledge and
            agree that the Company shall have the right to retain your
            information for as long as it deems fit and to be in compliance with
            applicable provisions of the law.
            <br />
            <br />
            13.13. Fees: The Company reserves the right to charge a fee for the
            Services and non-payment may result in denial of Services.
            <br />
            <br />
            13.14. Contact Us: If there are any questions or grievances or
            complaints regarding these Terms, you may contact us at the address
            given below:&nbsp;
            <br />
            <br />
            <b>Grievance Officer</b>
            <br />
            <br />
            <strong>Name:</strong> Rajendra Kumar Bhalotia
            <br />
            <br />
            <strong>Address:</strong> Suite 701, 10 Clive Row, Rampuria
            Chambers, Kolkata, West Bengal - 700001
            <br />
            <br />
            <strong>Email:</strong> help@Kbiafiling.in&nbsp;
          </p>
          <br />
          <br />
          <p className="text-sm">
            <strong>14. Additional Terms for Tax Return Filing Services</strong>
            <br />
            <br />
            The terms set out in this clause apply in addition to the Terms
            contained in Clauses 1 to 13, if the User opts for tax return filing
            services.
            <br />
            <br />
            14.1 You acknowledge, agree and authorise, the Company to collect,
            store, process your information and further transferring and sharing
            information (including personal information) with third parties
            including, payment gateways, banks, KYC Registration, Income Tax
            Department (ITD) and other entities for the purpose of the Services.
            <br />
            <br />
            14.2 The Company is constantly innovating in order to provide the
            best possible experience for its users. You acknowledge and agree
            that the form and nature of the Platform and Services which it
            provides may change from time to time without prior notice to you.
            <br />
            <br />
            14.3 As part of this continuing innovation, you acknowledge and
            agree that the Company may stop (permanently or temporarily)
            providing the Platform or Services (or any features within the
            Services) to you or to users generally at the Company's sole
            discretion, without prior notice to you. You may stop using the
            Services at any time. You do not need to specifically inform the
            Company when you stop using the Services.
            <br />
            <br />
            14.4 You acknowledge and agree that if the Company disables access
            to your account, you may be prevented from accessing the Services,
            your account details or any files or other content which is
            contained in your account.
            <br />
            <br />
            14.5 You authorise the company to add you as a ‘client’ on the ITD
            web services to submit ITR, retrieve ITR-V, refund status, Form
            26AS, etc.
            <br />
            <br />
            14.6 You acknowledge and agree that while the Company may not
            currently have set a fixed upper limit on the number of ITRs which
            may be filed through the Services or on the amount of storage space
            used for the provision of any Service, such fixed upper limits may
            be set by the Company at any time, at its own discretion.
            <br />
            <br />
            14.7 You agree and understand, in order to provide the ITR filing
            Services, you will need to submit your personal information and
            financial information.
            <br />
            <br />
            14.8 In order to prepare your ITR, to file your ITR, to provide
            advice about tax matters, you will need to provide information about
            your income, deductions, credits, dependents, etc. Collectively,
            this information is known as “Tax Return Information”. You agree
            that any information (including, the Tax Return Information) you
            give to the Company will always be accurate, correct and up to date.
            <br />
            <br />
            14.9 If you file ITRs for another individual, you should be doing so
            with the express consent of that individual after fully
            understanding the implications of this action. The Company will not
            be held responsible if you are doing this without the knowledge /
            consent of that person concerned. The Company will not be liable for
            any failure by you to obtain consent of the person concerned, and
            you agree to indemnify the Company against any claims arising from
            such person.
            <br />
            <br />
            14.10 In case of electronic filing, ITR shall not be deemed to have
            been filed unless it is successfully uploaded at the return filing
            platform of incometaxindiaefiling.gov.in. You are advised to cross
            check your account at incometaxindiaefiling.gov.in to confirm that
            return has been successfully filed. You acknowledge that you will be
            solely responsible for verifying that your ITR has been filed and
            received by the ITD and for taking appropriate alternative actions
            if necessary. We recommend you to retain a copy of your ITRs for
            your records.
            <br />
            <br />
            14.11 No Warranty: The Company takes great care in ensuring the
            correctness of your ITR. There are professionals (internal and third
            party) who work hard on ensuring the correctness of the tax returns
            However, the Company provides no guarantee or warranty on the
            correctness of your ITR due to incorrect submission of details from
            your end. You are required to review and ensure correctness of the
            details submitted by you. You will not hold the Company liable or
            responsible for any issue that arises from incorrect ITR filing due
            to submission of incorrect “Tax Return Information”.
            <br />
            <br />
            14.12 You agree and acknowledge that we may use external consultants
            (each of which is a separate and independent legal entity) or
            subcontractors to provide the Platform and applicable Services. In
            case we use such consultants, you authorise the Company to share
            your information with such consultants for providing you the
            Services.
          </p>
        </div>
      </Container>
    </Container>
  );
}

export default TC;
